/**
 * @returns: Returns all years from 50 years back from the current year
 */
export const getAllYears = () => {
  const currentYear = new Date().getFullYear()
  const range = (start: number, stop: number, step: number) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step,
    )
  return range(currentYear, currentYear - 50, -1)
}


